/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/share/components/CopyEmbedCodeModal.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useEmbedState } from '../embedStore.migrated';
import IFrameEmbedView from './IFrameEmbedView.migrated';
import ReactEmbedView from './ReactEmbedView.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CopyEmbedCodeModal = ({
  onClose,
  title,
  lessonId,
  contentId,
  shortId,
  language
}) => {
  const {
    selectedTabId,
    setSelectedTabId
  } = useEmbedState();
  const handleSelectionChange = event => setSelectedTabId(String(event.target.value));
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 800,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.title",
          options: {
            contentName: title
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      marginBlockStart: "400",
      style: {
        textAlign: 'unset'
      },
      children: /*#__PURE__*/_jsxs(Tabs, {
        marginBlockEnd: "200",
        onSelectedChange: handleSelectionChange,
        selected: selectedTabId,
        children: [/*#__PURE__*/_jsx(Tab, {
          tabId: "iframe",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.tabs.iframe"
          }),
          children: /*#__PURE__*/_jsx(IFrameEmbedView, {
            contentId: contentId,
            language: language,
            lessonId: lessonId,
            shortId: shortId
          })
        }), /*#__PURE__*/_jsx(Tab, {
          tabId: "react",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.tabs.react"
          }),
          children: /*#__PURE__*/_jsx(ReactEmbedView, {
            contentId: contentId,
            language: language,
            lessonId: lessonId,
            shortId: shortId
          })
        })]
      })
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/share/components/CopyEmbedCodeModal.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default CopyEmbedCodeModal;